import { IOfficeAppliancesType } from "../types/index";
import axios from "../../../../../utils/authAxios";

const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/OfficeAppliancesTypeConfig";

export const updateType = async (updatedType: IOfficeAppliancesType) => {
  const { data } = await axios.put(`${api_base_url}/EditType`, updatedType);
  return data;
};
